export default __webpack_public_path__ + "static/media/error-black.3598ec1e.png";